import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
});

// Attach JWT to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Silently refresh the token when the backend issues X-Refreshed-Token.
// On a true 401, clear local auth state and notify the app so it can show
// a user-friendly message (handled in AuthContext).
api.interceptors.response.use(
  (response) => {
    const refreshedToken = response.headers['x-refreshed-token'];
    // Basic JWT format check before trusting the header (three base64url segments).
    // Guards against a compromised CDN or XSS overwriting the stored token with garbage.
    const JWT_PATTERN = /^[\w-]+\.[\w-]+\.[\w-]+$/;
    if (refreshedToken && JWT_PATTERN.test(refreshedToken)) {
      localStorage.setItem('auth_token', refreshedToken);
    }
    return response;
  },
  (error) => {
    const isLoginEndpoint = error.config?.url?.includes('/api/auth/login');
    if (error.response?.status === 401 && !isLoginEndpoint) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_guest');
      window.dispatchEvent(new Event('auth-expired'));
    }
    return Promise.reject(error);
  }
);

export default api;
